module.exports = __webpack_public_path__ + "static/img/img-liveunopen.6fe313d3.png";